import translator from '@Components/Utilities/Translator';
import { WidgetButton } from '@Components/MuiWrappers/Button';

const ShippingEstimate = (props) => {
    return (
        (props.blockName === 'detail') ?
            <WidgetButton variant='contained' size='small' href={props.WidgetUrl} target='_blank' className={`${props.blockName}-shipping-estimate shipping-estimate`}>
                <img src={props.ImageURL} alt='' className={`${props.blockName}-shipping-estimate__icon shipping-estimate__icon`} />
                <div className={`${props.blockName}-shipping-estimate__text shipping-estimate__text`}>
                    {translator.translate('sandhills.shiptodayforaslowas')} <span className={`${props.blockName}-shipping-estimate__value shipping-estimate__value`}>{props.estimateDisplay}***</span>
                </div>
                <span className='visually-hidden'>({translator.translate('sandhills.opensinanewtab')})</span>
            </WidgetButton>
            :
            <div className={`${props.blockName}-shipping-estimate shipping-estimate`} >
                <a href={props.WidgetUrl} target='_blank' className={`${props.blockName}-shipping-estimate__link shipping-estimate__link`}>
                    {!props.skipImage && <img src={props.ImageURL} alt='' className={`${props.blockName}-shipping-estimate__icon shipping-estimate__icon`} />}
                    <div className={`${props.blockName}-shipping-estimate__text shipping-estimate__text`}>
                        {translator.translate('sandhills.shiptodayforaslowas')} <span className={`${props.blockName}-shipping-estimate__value shipping-estimate__value`}>{props.estimateDisplay}***</span>
                    </div>
                    <span className='visually-hidden'>({translator.translate('sandhills.opensinanewtab')})</span>
                </a>
            </div>
    );
};

export default ShippingEstimate;